import React, { useContext, useState } from "react";
import { QK } from "../../../base/qk";
import { useQuery } from "react-query";
import {
  getSecondaryAssesments,
  getVisitCarePlans,
} from "../../../api/services/notification";
import TableComponent from "../../TableComponent/TableComponent";
import { formatDateField, formatDateTime } from "../../../base/FormatTime";
import { Details, Visibility } from "@mui/icons-material";
import MyContext from "../../../context/MyContext";

const CarePlansContent = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const careplanPerPage = 10;
  const { locationID } = useContext(MyContext);

  const { data: careplans, isLoading } = useQuery(
    [QK.visitCareplans, currentPage, locationID],
    () => getVisitCarePlans(currentPage, locationID),
    { keepPreviousData: true, enabled: !!currentPage || !!locationID }
  );

  const totalRecords = careplans?.count || 0;
  const totalPages = Math.ceil(totalRecords / careplanPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);
  const handleCarePlanView = (care) => {
    console.log(care);
  };

  const columns = [
    {
      field: "start_time",
      headerName: "Date",
      render: (value) => formatDateField(value),
    },
    {
      field: "client_name",
      headerName: "Client Name",
    },

    { field: "care_plan_name", headerName: "Care Plan" },
  ];

  const actions = [
    {
      icon: <Visibility color="info"></Visibility>,
      handler: (val) => handleCarePlanView(val),
    },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={careplans?.results || []}
        isLoading={isLoading}
        actions={actions}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        size="small"
      />
    </div>
  );
};

export default CarePlansContent;
